import React from 'react';

const TriangleIcon = () => {
    return (
        <svg
            width="24"
            height="36"
            viewBox="0 0 24 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.9994 27.4103H5.93944C2.46944 27.4103 1.01944 24.9303 2.69944 21.9003L5.81944 16.2803L8.75944 11.0003C10.5394 7.79027 13.4594 7.79027 15.2394 11.0003L18.1794 16.2903L21.2994 21.9103C22.9794 24.9403 21.5194 27.4203 18.0594 27.4203H11.9994V27.4103Z"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.4425 25.9996L12.0025 19.3896L2.5625 25.9996"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 9V19.39"
                stroke="#292D32"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default TriangleIcon;
